/**
 * @desc: -  日工资 追号记录弹出框
 * @author: danny
 */

import {DateGroup,RangeGroup,SearchGroup,Pagintaion,Bread} from "../ReportComponent.jsx";
import React from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as baseAction from '../../../../actions/baseAction'
import * as userAction from '../../../../actions/userAction'
import * as commonAction from "../../../../actions/commonAction";
import * as reportAction from "../../../../actions/reportAction";

import ReportBase from '../ReportBase.jsx'
import Popup from "../../../../components/modal/popup.jsx";
class LotteryAddRecord extends ReportBase{
	constructor(props){
		super(props)
		this.state.orderBy = 'username'
	}
	refer(){
		const {startDate,endDate,rangeIndex,pageNum,orderBy,sort,rangeOptionValue,searchValue} = this.state;
		//this.props.$$REPORT.getWinLossSummery(startDate,endDate,searchValue,rangeOptionValue,pageNum,orderBy,sort)
		this.props.$$REPORT.getLotteryBetHis(startDate,endDate,rangeOptionValue,0,'',0,pageNum)
		
		this.props.$$REPORT.getTraceHis(
			startDate,
			endDate,
			rangeOptionValue,
			0,
			pageNum
		)
	}
	
	breadRefer(){

	}
	
	render(){
		const __base = this.props.__BASE.toJS();
		const __report = this.props.__REPORT.toJS();
		
		if(!__report.current_view ) return <div></div>
		const {searchValue,orderBy,sort} = this.state;
		
		let lotteryRange = null;
		if(__report.current_view.lotteryList ){
			lotteryRange = _.values(__report.current_view.lotteryList).map((item,index)=>{
				return {
						title:item.cnname,
						optionValue:item.lotteryid
				       }
			})
			lotteryRange.unshift({title:'所有彩种',optionValue:0	})
		}
		
		
		return <div className="lottery-add-record-container report-commer-container pop-report-commer">
			<div className="pop-title-warp">
				<h6 className="title">追号记录</h6>
				{/*<a className="close-icon">X</a>*/}
			</div>
			
			
			<div className="page-warp">
				<div className="tool-warp">
					
					<DateGroup defaultStart={this.state.startDate.split(' ')[0]}
					           defaultEnd={this.state.endDate.split(' ')[0]}
					           onStartChange={this.onStartChange}
					           onEndChange={this.onEndChange}/>
					
					
					<RangeGroup title="" rangeMenuInfo={lotteryRange} rangeMenuClick={this.rangeMenuClick}/>
					
					<RangeGroup title=""
					            rangeMenuInfo={[{title:"所有玩法",optionValue:0}]}
					            rangeMenuClick={()=>{}}/>
					
					
					<label onClick={this.refer} className="blue-button">查询</label>
				</div>
				<div className="table-warp">
					<div className="table-title-warp">
						<label >用户名</label>
						<label >追号时间</label>
						<label >彩种</label>
						<label >开始期数</label>
						<label >玩法</label>
						<label >追号内容</label>
						<label >追号总金额</label>
						<label >完成金额</label>
						<label >取消金额</label>
						<label>终止后终止</label>
						<label>状态</label>
					</div>
					{
						__report.current_view.aProject &&  __report.current_view.aProject.length > 0 ?
							__report.current_view.aProject.map((item,index)=>{
								var codestr = item.code.length > 12 ?(item.code.substring(0,12)+"..."):item.code
								return <div className="title-body-warp" key={index}>
									<label>{item.username}</label>
									<label>{item.writetime.split(" ")[0]}</label>
									<label>{item.lotteryname}</label>
									<label>{item.issue}</label>
									<label>{item.methodname}</label>
									<label title={item.code}>{codestr}</label>
									<label>{item.totalprice}</label>
									<label>{item.bonus}</label>
									<label className='blue'>{item.isgetprize}</label>
									<label className='blue'>{item.iscancel == 0?"是":"否"}</label>
									<label className={item.prizestatus ==0 ?"green":"gray"}>{item.prizestatus == 0?"未完成":"已完成"}</label>
								
								</div>
							}):<div className="title-body-warp"><p className=" no-data">没有获取到数据</p></div>
					}
				
				</div>
				
				{
					this.renderPage('')
				}
			
			</div>
			

		</div>
	}
}

reactMixin(LotteryAddRecord.prototype, ImmutableMixin);

function mapStateToProps(state) {
	return {
		__BASE: state.base,
		__USER: state.user,
		__REPORT:state.report
	}
}

function mapDispatchToProps(dispatch) {
	return {
		$$USER: bindActionCreators(userAction, dispatch),
		$$COMMON: bindActionCreators(commonAction, dispatch),
		$$BASE: bindActionCreators(baseAction, dispatch),
		$$REPORT:bindActionCreators(reportAction, dispatch),
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(LotteryAddRecord)
